export default "__VITE_ASSET___SNu3Kr5__"